module.exports = __webpack_public_path__ + "img/pgn03.57b82a0c.png";